import Swiper from 'swiper';
import {A11y, Navigation, Pagination, Controller, Thumbs, Autoplay, EffectFade} from 'swiper/modules';

window.Swiper = Swiper;


export function initSwiper() {
    const sliders = document.querySelectorAll('.swiper-container');

    sliders.forEach((slider) => {
        if (!(slider instanceof HTMLElement)) return;

        // ❗ ПРОПУСКАЕМ about-items
        if (slider.classList.contains('about-items')) return;

        let uniqueOptions = {};

        if (slider.classList.contains('swiper-start')) {
            uniqueOptions = {
                modules: [Navigation, A11y],
                a11y: true,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.section-start .swiper-arrow-next',
                    prevEl: '.section-start .swiper-arrow-prev'
                },
            };
        }

		if (slider.classList.contains('tabs-slider')) {
			uniqueOptions = {
				modules: [Navigation, A11y],
				a11y: true,
				slidesPerView: 'auto',
				spaceBetween: 12,
			};
		}

		if (slider.classList.contains('swiper-banner-start')) {
			uniqueOptions = {
				modules: [Navigation, A11y, Autoplay, EffectFade],
				a11y: true,

				autoplay: {
					delay: 5000,
				},
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},

				navigation: {
					nextEl: '.section-start .swiper-arrow-next',
					prevEl: '.section-start .swiper-arrow-prev'
				},
			};
		}

        if (slider.classList.contains('news-detail-slider')) {
            uniqueOptions = {
                modules: [Navigation, A11y],
                a11y: true,

                navigation: {
                    nextEl: '.swiper-arrow-next',
                    prevEl: '.swiper-arrow-prev'
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    450: {
                        slidesPerView: 1.6,
                        spaceBetween: 20,
                    },
                    991: {
                        slidesPerView: 2.5,
                        spaceBetween: 20,
                    },
                    1240: {
                        slidesPerView: 2.2,
                        spaceBetween: 20,
                    }
                }
            };
        }

        if (slider.classList.contains('project-swiper')) {
            uniqueOptions = {
                modules: [Navigation, A11y],
                a11y: true,

                navigation: {
                    nextEl: '.project-slider .swiper-arrow-next',
                    prevEl: '.project-slider .swiper-arrow-prev'
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    767: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                }
            };
        }

        if (slider.classList.contains('project-detail__swiper')) {
            uniqueOptions = {
                modules: [Navigation, A11y],
                a11y: true,

                navigation: {
                    nextEl: '.slider-detail .swiper-arrow-next',
                    prevEl: '.slider-detail .swiper-arrow-prev'
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    767: {
                        slidesPerView: 2.2,
                        spaceBetween: 24,
                    },
                    1190: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                }
            };
        }

        if (slider.classList.contains('news-swiper')) {
            uniqueOptions = {
                modules: [Navigation, A11y],
                a11y: true,
                navigation: {
                    nextEl: '.news-slider .swiper-arrow-next',
                    prevEl: '.news-slider .swiper-arrow-prev'
                },
                breakpoints: {
                    320: {slidesPerView: 1.4, spaceBetween: 12},
                    992: {slidesPerView: 2.5, spaceBetween: 16},
                    1240: {slidesPerView: 3, spaceBetween: 20},
                },
            };
        }

        if (slider.classList.contains('reviews-swiper')) {
            uniqueOptions = {
                modules: [Navigation, A11y],
                a11y: true,
                navigation: {
                    nextEl: '.reviews-slider .swiper-arrow-next',
                    prevEl: '.reviews-slider .swiper-arrow-prev'
                },
                breakpoints: {
                    320: {slidesPerView: 1.4, spaceBetween: 12},
                    600: {slidesPerView: 2.2, spaceBetween: 12},
                    991: {slidesPerView: 3.4, spaceBetween: 20},
                    1240: {slidesPerView: 4, spaceBetween: 24},
                },
            };
        }

        new Swiper(slider, uniqueOptions);
    });

    initAboutItems();
    initAboutHistory();
    productSlider();
}

let aboutItemsSwiper: Swiper | null = null;
const breakpoint = window.matchMedia('(max-width: 990px)');

function initAboutItems() {
    const container = document.querySelector<HTMLElement>('.about-items');
    if (!container) return;

    const enable = () => {
        if (aboutItemsSwiper) return;

        aboutItemsSwiper = new Swiper(container, {
            modules: [Pagination],
            slidesPerView: 1,
            spaceBetween: 16,
            autoHeight: true,
            pagination: {
				el: container.querySelector('.swiper-pagination'),
				clickable: true,
            }
        });
    };

    const disable = () => {
        if (!aboutItemsSwiper) return;

        aboutItemsSwiper.destroy(true, true);
        aboutItemsSwiper = null;
    };

    const check = () => {
        breakpoint.matches ? enable() : disable();
    };

    check();
    breakpoint.addEventListener('change', check);
}

const isMobile = () => window.innerWidth < 991;

function initAboutHistory() {
    const yearItems = Array.from(
        document.querySelectorAll<HTMLElement>('.about-history__year-item')
    );
    const track = document.querySelector<HTMLElement>('.about-history__year-track');
    const textEl = document.querySelector<HTMLElement>('.about-history__text');

    if (!yearItems.length || !track || !textEl) return;

    const textSwiper = new Swiper(textEl, {
        modules: [Navigation, A11y],
        slidesPerView: 1,
		autoHeight: true,
        navigation: {
            nextEl: '.about-history .swiper-arrow-next',
            prevEl: '.about-history .swiper-arrow-prev',
        },
        a11y: true,
    });

    const isMobile = () => window.innerWidth < 991;

    const getOffset = (index: number) => {
        let offset = 0;

        for (let i = 0; i < index; i++) {
            if (isMobile()) {
                offset += yearItems[i].offsetWidth + 16;
            } else {
                offset += yearItems[i].classList.contains('is-active')
                    ? 68 + 48
                    : 36 + 24;
            }
        }

        return offset;
    };

    const getItemSize = (el: HTMLElement) => {
        const rect = el.getBoundingClientRect();
        const styles = window.getComputedStyle(el);

        return isMobile()
            ? rect.width + parseFloat(styles.marginRight)
            : rect.height + parseFloat(styles.marginBottom);
    };

    const setActive = (index: number) => {
        yearItems.forEach(el => el.classList.remove('is-active'));
        yearItems[index].classList.add('is-active');

        // ⏳ ждём перерасчёт размеров
        requestAnimationFrame(() => {
            const offset = getOffset(index);

            track.style.transform = isMobile()
                ? `translateX(-${offset - 2}px)`
                : `translateY(-${offset}px)`;
        });

        textSwiper.slideTo(index);
    };

    yearItems.forEach((item, index) => {
        item.addEventListener('click', () => setActive(index));
    });

    textSwiper.on('slideChange', () => {
        setActive(textSwiper.activeIndex);
    });

    // 🔥 важно: пересчёт при ресайзе
    window.addEventListener('resize', () => {
        setActive(textSwiper.activeIndex);
    });

    // начальное состояние
    setActive(0);
}

function productSlider() {
    // Мини-слайдер (миниатюры)
    const sliderSmall = new Swiper('.slider-small', {
        modules: [Thumbs],
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        loop: false,
        centeredSlides: false,
        watchOverflow: true,       // отключает прокрутку, если слайдов мало
        observer: true,            // следит за изменением DOM
        observeParents: true,      // отслеживает изменения родителей
        breakpoints: {
            0: { slidesPerView: 5, spaceBetween: 6 },
            800: { slidesPerView: 7, spaceBetween: 12 },
            1280: { slidesPerView: 5, spaceBetween: 0 },
        },
        on: {
            init: function () {
                if (this.slides.length <= this.params.slidesPerView) {
                    this.allowSlideNext = false;
                    this.allowSlidePrev = false;
                }
            },
        },
    });

    // Большой слайдер
    const sliderBig = new Swiper('.slider-big', {
        modules: [Thumbs],
        slidesPerView: 1,
        spaceBetween: 0,
        thumbs: {
            swiper: sliderSmall, // связываем с миниатюрами
        },
        on: {
            slideChange: () => {
                // Находим все видео в слайдере
                const videos = document.querySelectorAll('.slider-big video');
                videos.forEach(video => {
                    video.pause(); // останавливаем любое видео
                });
            },
        },
    });
}
